export const COPILOT_PROMPT_SOURCE_QUERY_PARAM = "prompt";
export const COPILOT_PROMPT_SOURCE_WIDGET = "widget";
export const COPILOT_PROMPT_LAUNCH_ID_QUERY_PARAM = "launchId";
export const COPILOT_SESSION_ID_QUERY_PARAM = "copilotSessionId";
export const AUTO_OPEN_ENTITY_TRIGGER_QUERY_PARAM = "autoOpenEntityTrigger";

export const COPILOT_COMPOSER_ACTION_SOURCE = "copilot_composer";
